// @flow
import React from 'react';
import { connect } from 'react-redux';

import { PAGE_TRACKING } from 'Client/cms/toolkit/constants';
import { useRouter } from 'Client/router/useRouter';
import { TrackingPageLoad } from 'Tracking/tracking-pageload/TrackingPageLoad.jsx';
import { mapStateToProps as mapDefaultToCurrentBookingCriteria } from 'Components/widgets/booking-engine-form/BookingEngineForm.container.jsx';
import { pageTrackingResolver } from './pageTracking.resolver';

type BookingCriteria = {
  initialDuration: number,
  initialNumberOfAdults: number,
  initialNumberOfChildren: number,
};

type GQLProps = {
  resort: Resort,
  price: {
    bestPrice: {
      value: number,
    },
    initialPrice: {
      value: number,
    },
    termsAndConditions: {
      departureCity: {
        name: string,
        value: string,
      },
      departureDate: number,
    },
  },
  bookingCriteria: BookingCriteria,
};

type TrackingProps = {
  trackingData: {
    [string]: string,
  },
};

type Props = {
  ...$Exact<TrackingProps>,
  ...$Exact<GQLProps>,
};

function DynamicPageLoadTracking({ trackingData }: TrackingProps) {
  // $FlowFixMe
  return <TrackingPageLoad {...trackingData} />;
}

function mapStateToProps(state, props) {
  const { location, trackingData = {}, resort = {} } = props;
  const { isProductPage = false } = trackingData;
  if (!isProductPage) return { trackingData };
  const { adultsNumber, kids, duration } = mapDefaultToCurrentBookingCriteria(state, {
    ...trackingData,
    location,
    resort,
  });
  const kidsNumber = kids.length;
  delete trackingData.bookingCriteria;
  return {
    trackingData: {
      ...trackingData,
      resortAdult: adultsNumber,
      resortChildren: kidsNumber,
      resortNightNumber: duration,
      resortTotalParticipant: adultsNumber + kidsNumber,
    },
  };
}

const ConnectedDynamicPageLoadTracking = connect(mapStateToProps)(DynamicPageLoadTracking);
const Component = (props: Props) => {
  const { location } = useRouter<UrlParams, QueryParams>();
  return <ConnectedDynamicPageLoadTracking {...props} location={location} />;
};
export const pageTrackingDescriptor = {
  name: PAGE_TRACKING,
  component: Component,
  props: pageTrackingResolver.props,
  resolve: pageTrackingResolver.resolve,
};
